"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./TooltipStyles"));
var styled_components_1 = require("styled-components");
var react_dom_1 = require("react-dom");
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.position, position = _b === void 0 ? "bottom" : _b, theme = _a.theme, width = _a.width, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, zIndex = _a.zIndex;
    var _d = React.useState({ top: 0, left: 0 }), coords = _d[0], setCoords = _d[1];
    var _e = React.useState(false), visible = _e[0], setVisible = _e[1];
    var tooltipRef = React.useRef(null);
    var handleMouseEnter = function (event) {
        var rect = event.currentTarget.getBoundingClientRect();
        var top = 0, left = 0;
        var margin = 12;
        switch (position) {
            case "top":
                top = rect.top - margin;
                left = rect.left + rect.width / 2;
                break;
            case "bottom":
                top = rect.bottom + margin;
                left = rect.left + rect.width / 2;
                break;
            case "left":
                top = rect.top + rect.height / 2;
                left = rect.left - margin;
                break;
            case "right":
                top = rect.top + rect.height / 2;
                left = rect.right + margin;
                break;
            default:
                break;
        }
        setCoords({ top: top, left: left });
        setVisible(true);
    };
    var handleMouseLeave = function () {
        setVisible(false);
    };
    return (React.createElement(Styled.TooltipContainer, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, fullWidth: fullWidth },
        React.createElement(Styled.TooltipWrapper, null,
            children,
            content &&
                (0, react_dom_1.createPortal)(React.createElement(Styled.TooltipContent, { position: position, top: coords.top, left: coords.left, visible: visible, ref: tooltipRef, width: width, isDarkTheme: (theme === null || theme === void 0 ? void 0 : theme.themeName) === "dark", zIndex: zIndex }, content), document.body))));
};
exports.default = (0, styled_components_1.withTheme)(Tooltip);
